export const PRIMARY = '#3e9a73';
export const PRIMARY_DARK = '#2d7a5a';
export const PRIMARY_LIGHT = '#3e9a7318';
export const PRIMARY_SURFACE = '#f0f9f4';
